import { create } from "zustand";
import { TransactionState } from "@engine/state-machine/transitions";
import { createInitialState, step as engineStep, runToEnd } from "@engine/simulator";

export type SimulatorStore = {
  state: TransactionState;

  // actions
  step: () => void;
  runAll: () => void;
  reset: () => void;
  setState: (state: TransactionState) => void;
  setAmount: (amount: string) => void;
};

export const useSimulatorStore = create<SimulatorStore>((set, get) => ({
  state: createInitialState(),

  step: () => {
    const next = engineStep(get().state);
    set({ state: next });
  },

  runAll: () => {
    const finalState = runToEnd(get().state);
    set({ state: finalState });
  },

  reset: () => {
    set({ state: createInitialState() });
  },

  setState: (state) => set({ state }),

  setAmount: (amount) => set(() => {
    // Preserve the new amount
    const nextAmount = amount;
    // Re-run the entire transaction engine from scratch to propagate this amount
    // to all structuredData, isoMessage, and encryptedPayload fields!
    let freshState = createInitialState();
    freshState.amount = nextAmount;
    const finalState = runToEnd(freshState);
    
    // We want to keep the UI's cinematic state untouched, just update the engine data
    return { state: finalState };
  })
}));